// Types
import { NewFeatureCarouselModalType } from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal.types';
import { Illustrations } from 'Wpds/components/illustration';

// Constants
import Colors from 'Wpds/colors/ColorConstants';

// Slugs in this file are primarily used for
// tracking purpose. Please be mindful if a
// change to a slug is needed
const slugPrefix = 'workspace-intro-modal';

export const WorkspaceIntrolModalData = {
  slug: slugPrefix,
  slides: [
    {
      slug: 'welcome',
      title: 'Welcome to PI Perform!',
      imageBgColor: Colors.purple[25],
      image: Illustrations.person_at_desk_in_video_call_with_purple_bg,
      imageWidth: '200px',
      description: 'We’re here to help you make communication and transparency easier. Let’s go over the basics.',
    },
    {
      slug: 'workspaces',
      title: 'What are workspaces?',
      imageBgColor: Colors.purple[25],
      image: Illustrations.workspace_modal_invite,
      imageWidth: '450px',
      description:
        'Workspaces allow you to collaborate on meeting agendas, follow-ups, goals, and more with colleagues. The core components of workspace are Discussion Topics, Action Items, and Meeting Mode.',
    },
    {
      slug: 'discussion-topics',
      title: 'Discussion Topics',
      image: Illustrations.discussion_topics_explain,
      imageBgColor: Colors.purple[25],
      imageWidth: '233px',
      description:
        'Discussion Topics set the agenda for your meeting. Leave comments and upload files for each other’s topics to make sure everyone is on the same page.',
    },
    {
      slug: 'action-items',
      title: 'Action Items',
      imageBgColor: Colors.purple[25],
      image: Illustrations.action_items_explained,
      imageWidth: '297px',
      description:
        'Action Items build a culture of accountability for follow-up tasks with clear owners and due dates. Keep track of progress and details with comments. Complete the Action Item when you’re done.',
    },
    {
      slug: 'final',
      title: 'Start having great meetings',
      imageBgColor: Colors.purple[25],
      image: Illustrations.three_people_at_table_in_conference_call_with_purple_bg,
      imageWidth: '200px',
      nextBtnLabel: `I'm Ready`,
      description:
        'Use Meeting Mode once your workspace is set up and you’re ready to have your first meeting. Meeting Mode helps you stay in sync, keeps track of meeting notes, and sends everyone a recap of what was discussed at the end.',
    },
  ],
} as NewFeatureCarouselModalType;
